import React from 'react';
import { Button, Typography } from 'antd';
import Slider from "react-slick";
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

const { Paragraph } = Typography;

export const Offers = ({ data, offersRef }) => {

    let breakpoints = useBreakpoint();

    const settings = {
        infinite: Array.isArray(data.offers) && data.offers.length > 3 ? true : false,
        speed: 500,
        autoplaySpeed: 10000,
        centerMode: false,
        autoplay: true,
        slidesToShow: breakpoints.xl ? 3 : breakpoints.md ? 2 : 1,
        slidesToScroll: 1,
        nextArrow: <div><BsChevronRight /></div>,
        prevArrow: <div><BsChevronLeft /></div>
    };

    if (!Array.isArray(data?.offers) || data.offers.length <= 0) return null;

    return (
        <React.Fragment>
            {
                Array.isArray(data?.offers) && data.offers.length &&
                <h3 ref={offersRef}>Exclusive Offers</h3>
            }
            <div id='hotel_offers'>
                <Slider {...settings}>
                    {
                        Array.isArray(data?.offers) && data.offers
                            .map((e, i) => (
                                <div key={e.title} className={`w-100 offer-card ${breakpoints.md ? 'px-3' : ''}`}>
                                    <div className='offer-card-body border border-light mx-1'>
                                        <div
                                            style={{
                                                height: 200,
                                                backgroundImage: `url('${e.picture}')`,
                                                backgroundSize: 'cover'
                                            }}
                                            className='w-100 overflow-hidden rounded'
                                        >
                                            {/* <img src={e.picture} className='img img-fluid' alt={e.offer_name} /> */}
                                        </div>
                                        <div className='offer-card-text overflow-auto px-2'>
                                            <h4 className='my-3 color-primary fw-normal text-primary'>{e.offer_name}</h4>
                                            <p><span className='fw-bold'>Starting From: </span>{e.currency}{e.price}</p>
                                            <Paragraph
                                                ellipsis={{ rows: 2, symbol: 'read more' }}
                                            >
                                                {e.description}
                                            </Paragraph>
                                            <div className='w-100 text-center'>
                                                <a href={e.url} target='_blank' rel='noreferrer noopner'>
                                                    <Button shape='round' type='primary' className='' size='large'>
                                                        Book Now
                                                    </Button>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                    }
                </Slider>
            </div>
            <div className='separator my-3 my-md-4' />
        </React.Fragment>
    )
}
